import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

class Carga extends React.Component {
  render() {
    return (
      <Backdrop
        sx={{
          color: "#ffffff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          backgroundColor: "rgba(15, 23, 42, 0.65)",
          backdropFilter: "blur(4px)",
          flexDirection: "column",
          gap: 2,
        }}
        open={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#ffffff",
            padding: "2rem 3rem",
            borderRadius: "16px",
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          }}
        >
          <CircularProgress size={50} thickness={4} sx={{ color: "#0ea5e9" }} />
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontWeight: 600,
              color: "#1e293b",
            }}
          >
            Cargando información...
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#64748b",
            }}
          >
            Por favor espere un momento
          </Typography>
        </Box>
      </Backdrop>
    );
  }
}

export default Carga;
